import { TextField } from "@mui/material";
import { useContext } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
//
// ################################################################################
//
const AnteojoObservaciones = () => {
  const { anteojoObservaciones, handleChangeAnteojoObservaciones, gaAction } =
    useContext(GestionAtencionContext);

  const { observaciones } = anteojoObservaciones;

  return (
    <>
      <TextField
        sx={{ width: "100%", mb: 1 }}
        id="observaciones"
        variant="outlined"
        multiline
        maxRows={5}
        name="observaciones"
        value={observaciones}
        onChange={handleChangeAnteojoObservaciones}
        disabled={gaAction.cu === "view"}
      />
    </>
  );
};
export default AnteojoObservaciones;
